export enum StatusKYCStepTwo {
  REJECTED_BY_WEBSITE = 'REJECTED_BY_WEBSITE',
  REJECTED_BY_INDUSTRY = 'REJECTED_BY_INDUSTRY',
  REJECTED_BY_DOCUMENTATION = 'REJECTED_BY_DOCUMENTATION',
  COMPLETED = 'COMPLETED',
  PENDING = 'DISABLED',
  ENABLED = 'ENABLED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
}
